 
import { React, useEffect, useState, useRef, useMemo } from "react";
import { genericGet, genericPost } from "../../services/Api";
import { SUCCESS_RESULT, ENDPOINTS } from "../../Constants";
import cogoToast from "cogo-toast";
import { Modal } from "react-bootstrap";
import { FaSpinner, FaTimes } from "react-icons/fa";

const Workflows = () => {
  const [workflows, setworkflows] = useState([])
  const [workflow_levels, setworkflow_levels] = useState([])
  const [selectedWorkflow, setselectedWorkflow] = useState(null)
  const [show_create_level_modal, setshow_create_level_modal] = useState(false)
  const [show_update_level_modal, setshow_update_level_modal] = useState(false)

  const [selectedWorkflowLevel, setselectedWorkflowLevel] = useState(null)
const [IsLoading, setIsLoading] = useState(false)
useEffect(() => {
  listWorkflows();
   
}, [])


const listWorkflowLevels=(id)=>{
 

  genericPost(ENDPOINTS.LIST_WORKFLOW_LEVELS,{
    "workflow_id": id
})
  .then((res) => {
    setIsLoading(false);
    if (res.status == 200) {
      if (res.data.status == SUCCESS_RESULT) {
        let responseData = res.data.data;
       
        setworkflow_levels(responseData);
  
        }
      
      } else {
        cogoToast.error(res.data.message, {});
      }
    
  })
  .catch((err) => {
    setIsLoading(false);
    console.log(err);
  });
} 
const listWorkflows =()=>{
  genericGet(ENDPOINTS.LIST_WORKFLOWS)
  .then((res) => {
    setIsLoading(false);
    if (res.status == 200) {
      if (res.data.status == SUCCESS_RESULT) {
        let responseData = res.data.data;
       setworkflows(responseData);
  
        }
      
      } else {
        cogoToast.error(res.data.message, {});
      }
    
  })
  .catch((err) => {
    setIsLoading(false);
    console.log(err);
  });
} 
const createWorkflowLevel=(e)=>{


  e?.preventDefault(); 
  let data={
      
      "workflow_id":selectedWorkflow?.id,
      "name":e.target.name.value,
      "level_no":e.target.level_no.value,
      "type":e.target.type.value,
      "user_type":e.target.user_type.value,
  }
  
  genericPost(ENDPOINTS.CREATE_WORKFLOW_LEVEL,data)
  .then((res) => {
    
    setIsLoading(false);
    if (res.status == 200) {
 
      let responseData = res.data;
      if (res.data.status == SUCCESS_RESULT) {
        
        cogoToast.success(responseData.message);
  setshow_create_level_modal(false);
  listWorkflowLevels(selectedWorkflow?.id);
        }
      else
      {
        cogoToast.error(responseData.message);
      }
      } else {
        cogoToast.error(res.data.message, {});
      }
    
  })
  .catch((err) => {
    setIsLoading(false);
    console.log(err);
  });

}

const updateWorkflowLevel=(e)=>{


  e?.preventDefault(); 
  let data={
      
    "workflow_level_id":e.target.workflow_level_id.value,
      "workflow_id":e.target.workflow_id.value,
      "name":e.target.name.value,
      "level_no":e.target.level_no.value,
      "type":e.target.type.value,
      "user_type":e.target.user_type.value,
  }
  
  genericPost(ENDPOINTS.UPDATE_WORKFLOW_LEVEL,data)
  .then((res) => {
    
    setIsLoading(false);
    if (res.status == 200) {
 
      let responseData = res.data;
      if (res.data.status == SUCCESS_RESULT) {
        
        cogoToast.success(responseData.message);
  setshow_update_level_modal(false);
  listWorkflowLevels(selectedWorkflow?.id);
        }
      else
      {
        cogoToast.error(responseData.message);
      }
      } else {
        cogoToast.error(res.data.message, {});
      }
    
  })
  .catch((err) => {
    setIsLoading(false);
    console.log(err);
  });

}
  return (
    <div className='card'>

    
    <div className='card-body'>

<div className="row">
  <div className="col-md-12">
  <h1>
  

  WorkFlows
</h1>

<table className="info_table">
<thead>
 
    <th> Name</th>
    <th> Total levels</th>

    <th>Actions</th>

 
</thead>
{workflows?.map((w)=> {
return <tr>
  <td>{w.name}</td>
  <td>{w.total_levels}</td>
  <td>
    <button className='btn-sm btn-primary' onClick={()=>{
      setselectedWorkflow(w);
   
        listWorkflowLevels(w.id);
       
      
    }}> .. </button>  
  </td>



</tr>
})}
</table>
  </div>
  
</div>





  


    </div>
    </div>
  )
}

export default Workflows